import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import { strictFetcher } from './strict-fetcher'

/// One day of `GET /alkane/address/:addr/equity` — REAL end-of-day balances
/// (the ledger's replayed deltas) × each token's daily close. The server is
/// explicit about scope (alkanes only — BTC cash has no history there) and
/// about what it could not price (`unpriced`), and this hook carries both
/// through untouched.
export interface EquityPoint {
	ts: number
	usd: number
}

interface EquityBody {
	address: string
	days: number
	scope: string
	points: EquityPoint[]
	unpriced: string[]
	truncated: boolean
}

/// `unavailable` covers both "endpoint not deployed yet" and "upstream down"
/// (a thrown error, strictFetcher) — the UI keeps its honest empty frame.
export default function useEquity(
	address: string | null,
	days: number
): {
	points: EquityPoint[]
	unpriced: string[]
	truncated: boolean
	unavailable: boolean
	isLoading: boolean
} {
	const { data, error, isLoading } = useSwr<EquityBody>(
		address ? `${API_URL}/alkane/address/${address}/equity?days=${days}` : null,
		strictFetcher,
		{ refreshInterval: 300_000, revalidateOnFocus: false }
	)
	return {
		points: Array.isArray(data?.points) ? data!.points : [],
		unpriced: Array.isArray(data?.unpriced) ? data!.unpriced : [],
		truncated: data?.truncated ?? false,
		unavailable: error !== undefined,
		isLoading
	}
}
